// extracted by css-extract-rspack-plugin
export default {"TriggerContainer":"b_Tuj","TriggerContainerIcon":"UOjLR","TextSchema":"LWUAw","BackButtonLabel":"bM2WH"};